<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <m-card-list
          title="Kelola Peran"
          search
          id-key
          filter
          refresh
          addText="Jenis Diklat"
          addHint="Tambah"
          @refresh="load"
          :items="items"
          footerLabel="Peran"
          @search="
            search => {
              textSearch = search;
              load();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
          footer
        >
          <template v-slot:items="{ props, item }">
            <v-container>
              <v-row class="mx-3">
                <v-col cols="3" lg="1" md="1" sm="1">
                  <v-avatar width="50" height="50" :size="45" color="secondary2">
                    <v-icon class="secondary--text">mdi-book-open</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="12" md="10" lg="10">
                  <v-row>
                    <v-col class="py-0" cols="12" sm="6">
                      <p class="caption my-0 py-0 grey--text align-left">Jenis Diklat</p>
                      <p class="font-weight-bold primary--text py-0">
                        {{ pVal(item, "keterangan") }}
                      </p>
                    </v-col>
                    <v-col class="py-0 text-center" cols="12" sm="6">
                      <p class="caption my-0 py-0 grey--text align-left">Kode</p>
                      <p class="py-0 font-weight-bold">
                        {{ item.id }}
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col lg="1" md="1" sm="1" cols="1">
                  <m-menu right class="clearfix" style="float:right" :items="more_menu" :object="item" />
                </v-col>
              </v-row>
            </v-container>
            <v-divider />
          </template>
        </m-card-list>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
import { ALERT_INFO } from "@/const";
import ChangeDlg from "../components/FormPeran.vue";

export default {
  components: {
    ChangeDlg
    // DetailDlg
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      itemMapels: [],
      peran: null,
      textSearch: null,
      page: null,
      cp: 1,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Ubah Peran",
          click: (i, o) => this.edit(o)
        }
      ]
    };
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    }
  },
  activated() {
    this.load();
  },
  methods: {
    load() {
      return this.$store
        .dispatch("kelola/getJenisDiklat", {
          instansi_id: this.instansi_id,
          params: {
            page: this.cp,
            s: this.textSearch,
            peran: this.peran
          }
        })
        .then(res => {
          this.items = res;
        })
        .catch(e => e);
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },

    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus peran mata pelajaran ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.name}<br>
        </div>`,
        {
          cancelOnly: item.laporan_accepted_count > 0 ? true : false
        }
      )
        .then(() => this.$store.dispatch("peran/drop", item))
        .then(() => {
          this.$info("Peran " + item.name + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  },
  watch: {}
};
</script>
